// Complete countries data with phone codes
export const countries = [
  { code: 'AF', phone: '93' }, // Afghanistan
  { code: 'AL', phone: '355' }, // Albania
  { code: 'DZ', phone: '213' }, // Algeria
  { code: 'AS', phone: '1-684' }, // American Samoa
  { code: 'AD', phone: '376' }, // Andorra
  { code: 'AO', phone: '244' }, // Angola
  { code: 'AI', phone: '1-264' }, // Anguilla
  { code: 'AQ', phone: '672' }, // Antarctica
  { code: 'AG', phone: '1-268' }, // Antigua and Barbuda
  { code: 'AR', phone: '54' }, // Argentina
  { code: 'AM', phone: '374' }, // Armenia
  { code: 'AW', phone: '297' }, // Aruba
  { code: 'AU', phone: '61' }, // Australia
  { code: 'AT', phone: '43' }, // Austria
  { code: 'AZ', phone: '994' }, // Azerbaijan
  { code: 'BS', phone: '1-242' }, // Bahamas
  { code: 'BH', phone: '973' }, // Bahrain
  { code: 'BD', phone: '880' }, // Bangladesh
  { code: 'BB', phone: '1-246' }, // Barbados
  { code: 'BY', phone: '375' }, // Belarus
  { code: 'BE', phone: '32' }, // Belgium
  { code: 'BZ', phone: '501' }, // Belize
  { code: 'BJ', phone: '229' }, // Benin
  { code: 'BM', phone: '1-441' }, // Bermuda
  { code: 'BT', phone: '975' }, // Bhutan
  { code: 'BO', phone: '591' }, // Bolivia
  { code: 'BA', phone: '387' }, // Bosnia and Herzegovina
  { code: 'BW', phone: '267' }, // Botswana
  { code: 'BR', phone: '55' }, // Brazil
  { code: 'IO', phone: '246' }, // British Indian Ocean Territory
  { code: 'VG', phone: '1-284' }, // British Virgin Islands
  { code: 'BN', phone: '673' }, // Brunei
  { code: 'BG', phone: '359' }, // Bulgaria
  { code: 'BF', phone: '226' }, // Burkina Faso
  { code: 'BI', phone: '257' }, // Burundi
  { code: 'KH', phone: '855' }, // Cambodia
  { code: 'CM', phone: '237' }, // Cameroon
  { code: 'CA', phone: '1' }, // Canada
  { code: 'CV', phone: '238' }, // Cape Verde
  { code: 'KY', phone: '1-345' }, // Cayman Islands
  { code: 'CF', phone: '237' }, // Central African Republic
  { code: 'TD', phone: '235' }, // Chad
  { code: 'CL', phone: '56' }, // Chile
  { code: 'CN', phone: '86' }, // China
  { code: 'CO', phone: '57' }, // Colombia
  { code: 'KM', phone: '269' }, // Comoros
  { code: 'CK', phone: '682' }, // Cook Islands
  { code: 'CR', phone: '506' }, // Costa Rica
  { code: 'HR', phone: '385' }, // Croatia
  { code: 'CU', phone: '53' }, // Cuba
  { code: 'CW', phone: '599' }, // Curaçao
  { code: 'CY', phone: '357' }, // Cyprus
  { code: 'CZ', phone: '420' }, // Czech Republic
  { code: 'CD', phone: '243' }, // Democratic Republic of the Congo
  { code: 'DK', phone: '45' }, // Denmark
  { code: 'DJ', phone: '253' }, // Djibouti
  { code: 'DM', phone: '1-767' }, // Dominica
  { code: 'DO', phone: '1-809' }, // Dominican Republic
  { code: 'TL', phone: '670' }, // East Timor
  { code: 'EC', phone: '593' }, // Ecuador
  { code: 'EG', phone: '20' }, // Egypt
  { code: 'SV', phone: '503' }, // El Salvador
  { code: 'GQ', phone: '240' }, // Equatorial Guinea
  { code: 'ER', phone: '291' }, // Eritrea
  { code: 'EE', phone: '372' }, // Estonia
  { code: 'ET', phone: '251' }, // Ethiopia
  { code: 'FK', phone: '500' }, // Falkland Islands
  { code: 'FO', phone: '298' }, // Faroe Islands
  { code: 'FJ', phone: '679' }, // Fiji
  { code: 'FI', phone: '358' }, // Finland
  { code: 'FR', phone: '33' }, // France
  { code: 'PF', phone: '689' }, // French Polynesia
  { code: 'GA', phone: '241' }, // Gabon
  { code: 'GM', phone: '220' }, // Gambia
  { code: 'GE', phone: '994' }, // Georgia
  { code: 'DE', phone: '49' }, // Germany
  { code: 'GH', phone: '233' }, // Ghana
  { code: 'GI', phone: '350' }, // Gibraltar
  { code: 'GR', phone: '30' }, // Greece
  { code: 'GL', phone: '299' }, // Greenland
  { code: 'GD', phone: '1-473' }, // Grenada
  { code: 'GU', phone: '1-671' }, // Guam
  { code: 'GT', phone: '502' }, // Guatemala
  { code: 'GG', phone: '44-1481' }, // Guernsey
  { code: 'GN', phone: '224' }, // Guinea
  { code: 'GW', phone: '245' }, // Guinea-Bissau
  { code: 'GY', phone: '592' }, // Guyana
  { code: 'HT', phone: '509' }, // Haiti
  { code: 'HN', phone: '504' }, // Honduras
  { code: 'HK', phone: '852' }, // Hong Kong
  { code: 'HU', phone: '36' }, // Hungary
  { code: 'IS', phone: '354' }, // Iceland
  { code: 'IN', phone: '91' }, // India
  { code: 'ID', phone: '65' }, // Indonesia
  { code: 'IR', phone: '98' }, // Iran
  { code: 'IQ', phone: '964' }, // Iraq
  { code: 'IE', phone: '353' }, // Ireland
  { code: 'IM', phone: '44-1624' }, // Isle of Man
  { code: 'IL', phone: '972' }, // Israel
  { code: 'IT', phone: '39' }, // Italy
  { code: 'CI', phone: '225' }, // Ivory Coast
  { code: 'JM', phone: '1-876' }, // Jamaica
  { code: 'JP', phone: '81' }, // Japan
  { code: 'JE', phone: '44-1534' }, // Jersey
  { code: 'JO', phone: '962' }, // Jordan
  { code: 'KZ', phone: '7' }, // Kazakhstan
  { code: 'KE', phone: '254' }, // Kenya
  { code: 'KI', phone: '686' }, // Kiribati
  { code: 'XK', phone: '383' }, // Kosovo
  { code: 'KW', phone: '965' }, // Kuwait
  { code: 'KG', phone: '996' }, // Kyrgyzstan
  { code: 'LA', phone: '856' }, // Laos
  { code: 'LV', phone: '371' }, // Latvia
  { code: 'LB', phone: '961' }, // Lebanon
  { code: 'LS', phone: '266' }, // Lesotho
  { code: 'LR', phone: '231' }, // Liberia
  { code: 'LY', phone: '218' }, // Libya
  { code: 'LI', phone: '423' }, // Liechtenstein
  { code: 'LT', phone: '370' }, // Lithuania
  { code: 'LU', phone: '352' }, // Luxembourg
  { code: 'MO', phone: '853' }, // Macau
  { code: 'MK', phone: '389' }, // Macedonia
  { code: 'MG', phone: '261' }, // Madagascar
  { code: 'MW', phone: '265' }, // Malawi
  { code: 'MY', phone: '60' }, // Malaysia
  { code: 'MV', phone: '960' }, // Maldives
  { code: 'ML', phone: '223' }, // Mali
  { code: 'MT', phone: '356' }, // Malta
  { code: 'MH', phone: '692' }, // Marshall Islands
  { code: 'MQ', phone: '596' }, // Martinique
  { code: 'MR', phone: '222' }, // Mauritania
  { code: 'MU', phone: '230' }, // Mauritius
  { code: 'YT', phone: '262' }, // Mayotte
  { code: 'MX', phone: '52' }, // Mexico
  { code: 'FM', phone: '691' }, // Micronesia
  { code: 'MD', phone: '373' }, // Moldova
  { code: 'MC', phone: '377' }, // Monaco
  { code: 'MN', phone: '976' }, // Mongolia
  { code: 'ME', phone: '382' }, // Montenegro
  { code: 'MS', phone: '1-664' }, // Montserrat
  { code: 'MA', phone: '212' }, // Morocco
  { code: 'MZ', phone: '258' }, // Mozambique
  { code: 'MM', phone: '95' }, // Myanmar
  { code: 'NA', phone: '264' }, // Namibia
  { code: 'NR', phone: '674' }, // Nauru
  { code: 'NP', phone: '977' }, // Nepal
  { code: 'NL', phone: '31' }, // Netherlands
  { code: 'NC', phone: '687' }, // New Caledonia
  { code: 'NZ', phone: '64' }, // New Zealand
  { code: 'NI', phone: '505' }, // Nicaragua
  { code: 'NE', phone: '227' }, // Niger
  { code: 'NG', phone: '234' }, // Nigeria
  { code: 'NU', phone: '683' }, // Niue
  { code: 'NF', phone: '672' }, // Norfolk Island
  { code: 'KP', phone: '850' }, // North Korea
  { code: 'MP', phone: '1-670' }, // Northern Mariana Islands
  { code: 'NO', phone: '47' }, // Norway
  { code: 'OM', phone: '968' }, // Oman
  { code: 'PK', phone: '92' }, // Pakistan
  { code: 'PW', phone: '680' }, // Palau
  { code: 'PS', phone: '970' }, // Palestine
  { code: 'PA', phone: '507' }, // Panama
  { code: 'PG', phone: '675' }, // Papua New Guinea
  { code: 'PY', phone: '595' }, // Paraguay
  { code: 'PE', phone: '51' }, // Peru
  { code: 'PH', phone: '63' }, // Philippines
  { code: 'PN', phone: '64' }, // Pitcairn
  { code: 'PL', phone: '48' }, // Poland
  { code: 'PT', phone: '351' }, // Portugal
  { code: 'PR', phone: '1-787' }, // Puerto Rico
  { code: 'QA', phone: '974' }, // Qatar
  { code: 'RE', phone: '262' }, // Reunion
  { code: 'RO', phone: '40' }, // Romania
  { code: 'RU', phone: '7' }, // Russia
  { code: 'RW', phone: '250' }, // Rwanda
  { code: 'BL', phone: '590' }, // Saint Barthelemy
  { code: 'SH', phone: '290' }, // Saint Helena
  { code: 'KN', phone: '1-869' }, // Saint Kitts and Nevis
  { code: 'LC', phone: '1-758' }, // Saint Lucia
  { code: 'MF', phone: '1-590' }, // Saint Martin
  { code: 'PM', phone: '508' }, // Saint Pierre and Miquelon
  { code: 'VC', phone: '1-784' }, // Saint Vincent and the Grenadines
  { code: 'WS', phone: '685' }, // Samoa
  { code: 'SM', phone: '378' }, // San Marino
  { code: 'ST', phone: '239' }, // Sao Tome and Principe
  { code: 'SA', phone: '966' }, // Saudi Arabia
  { code: 'SN', phone: '221' }, // Senegal
  { code: 'RS', phone: '381' }, // Serbia
  { code: 'SC', phone: '248' }, // Seychelles
  { code: 'SL', phone: '232' }, // Sierra Leone
  { code: 'SG', phone: '65' }, // Singapore
  { code: 'SX', phone: '1-721' }, // Sint Maarten
  { code: 'SK', phone: '421' }, // Slovakia
  { code: 'SI', phone: '386' }, // Slovenia
  { code: 'SB', phone: '677' }, // Solomon Islands
  { code: 'SO', phone: '252' }, // Somalia
  { code: 'ZA', phone: '27' }, // South Africa
  { code: 'GS', phone: '500' }, // South Georgia and the South Sandwich Islands
  { code: 'KR', phone: '82' }, // South Korea
  { code: 'SS', phone: '211' }, // South Sudan
  { code: 'ES', phone: '34' }, // Spain
  { code: 'LK', phone: '94' }, // Sri Lanka
  { code: 'SD', phone: '249' }, // Sudan
  { code: 'SR', phone: '597' }, // Suriname
  { code: 'SJ', phone: '46' }, // Svalbard and Jan Mayen
  { code: 'SZ', phone: '268' }, // Swaziland
  { code: 'SE', phone: '46' }, // Sweden
  { code: 'CH', phone: '41' }, // Switzerland
  { code: 'SY', phone: '963' }, // Syria
  { code: 'TW', phone: '886' }, // Taiwan
  { code: 'TJ', phone: '992' }, // Tajikistan
  { code: 'TZ', phone: '255' }, // Tanzania
  { code: 'TH', phone: '66' }, // Thailand
  { code: 'TG', phone: '228' }, // Togo
  { code: 'TK', phone: '690' }, // Tokelau
  { code: 'TO', phone: '676' }, // Tonga
  { code: 'TT', phone: '1-868' }, // Trinidad and Tobago
  { code: 'TN', phone: '216' }, // Tunisia
  { code: 'TR', phone: '90' }, // Turkey
  { code: 'TM', phone: '993' }, // Turkmenistan
  { code: 'TC', phone: '1-649' }, // Turks and Caicos Islands
  { code: 'TV', phone: '688' }, // Tuvalu
  { code: 'VI', phone: '1-340' }, // U.S. Virgin Islands
  { code: 'UG', phone: '256' }, // Uganda
  { code: 'UA', phone: '380' }, // Ukraine
  { code: 'AE', phone: '971' }, // United Arab Emirates
  { code: 'GB', phone: '44' }, // United Kingdom
  { code: 'US', phone: '1' }, // United States
  { code: 'UM', phone: '1' }, // United States Minor Outlying Islands
  { code: 'UY', phone: '598' }, // Uruguay
  { code: 'UZ', phone: '998' }, // Uzbekistan
  { code: 'VU', phone: '678' }, // Vanuatu
  { code: 'VA', phone: '39' }, // Vatican
  { code: 'VE', phone: '58' }, // Venezuela
  { code: 'VN', phone: '84' }, // Vietnam
  { code: 'WF', phone: '681' }, // Wallis and Futuna
  { code: 'EH', phone: '212' }, // Western Sahara
  { code: 'YE', phone: '967' }, // Yemen
  { code: 'ZM', phone: '260' }, // Zambia
  { code: 'ZW', phone: '263' }, // Zimbabwe
];
